import _ from 'lodash';
import React, { PureComponent } from 'react';
import moment from 'moment';
import numeral from 'numeral';
import classNames from 'classnames';

class TooltipContent extends PureComponent {
  static displayName = 'DefaultTooltipContent';

  static defaultProps = {
    separator: ' : ',
    contentStyle: {},
    itemStyle: {},
    labelStyle: {},
  };

  renderContent() {
    const { colorMap, payload, itemStyle, itemSorter } = this.props;

    if (payload && payload.length) {
      const listStyle = { padding: 0, margin: 0 };

      const items = (itemSorter ? _.sortBy(payload, itemSorter) : payload).map(
        (entry, i) => {
          if (entry.type === 'none') {
            return null;
          }

          const finalItemStyle = {
            display: 'block',
            minWidth: '200px',
            paddingTop: 4,
            paddingBottom: 4,
            color: entry.color || '#000',
            ...itemStyle,
          };

          let { name, value } = entry;

          if (name === 'trend') {
            name = 'Trend';
            finalItemStyle.color = colorMap.trend;
          } else if (name === 'totalAmc8') {
            name = 'AMC 8';
            finalItemStyle.color = colorMap['amc-8'];
          } else if (name === 'totalAmc10') {
            name = 'AMC 10';
            finalItemStyle.color = colorMap['amc-10'];
          } else if (name === 'totalAmc12') {
            name = 'AMC 12';
            finalItemStyle.color = colorMap['amc-12'];
          } else if (name === 'totalFinraSie') {
            name = 'SIE';
            finalItemStyle.color = colorMap['finra-sie'];
          } else if (name === 'totalFinraSeries6') {
            name = 'Series 6';
            finalItemStyle.color = colorMap['finra-series-6'];
          } else if (name === 'totalFinraSeries63') {
            name = 'Series 63';
            finalItemStyle.color = colorMap['finra-series-63'];
          } else if (name === 'totalFinraSeries65') {
            name = 'Series 65';
            finalItemStyle.color = colorMap['finra-series-65'];
          } else if (name === 'totalFinraSeries66') {
            name = 'Series 66';
            finalItemStyle.color = colorMap['finra-series-66'];
          } else if (name === 'totalFinraBundleSieS7') {
            name = 'Bundle: SIE+S7';
            finalItemStyle.color = colorMap['finra-everything'];
          } else if (name === 'totalFinraEverything') {
            name = 'Bundle: Everything';
            finalItemStyle.color = colorMap['finra-everything'];
          } else if (name === 'totalFinraSeries7') {
            name = 'Series 7';
            finalItemStyle.color = colorMap['finra-series-7'];
          } else if (name === 'totalGre') {
            name = 'GRE';
            finalItemStyle.color = colorMap.gre;
          } else if (name === 'totalUsmleStep1') {
            name = 'USMLE Step 1';
            finalItemStyle.color = colorMap['usmle-step-1'];
          }

          if (!value) {
            return null;
          }

          value = numeral(value).format('$0,0.00');

          return (
            // eslint-disable-next-line react/no-array-index-key
            <li
              className="recharts-tooltip-item"
              key={`tooltip-item-${i}`}
              style={finalItemStyle}
            >
              <span className="recharts-tooltip-item-name">{name}: </span>
              <span className="recharts-tooltip-item-value">{value}</span>
            </li>
          );
        }
      );

      const total = numeral(_.sumBy(payload, 'value')).format('$0,0.00');

      const totalItemStyle = {
        display: 'block',
        paddingTop: 4,
        paddingBottom: 4,
        fontWeight: 600,
        color: '#393d48',
      };

      return (
        <ul className="recharts-tooltip-item-list" style={listStyle}>
          <li
            className="recharts-tooltip-item"
            key="tooltip-item-total"
            style={totalItemStyle}
          >
            <span className="recharts-tooltip-item-name">Total: </span>
            <span className="recharts-tooltip-item-value">{total}</span>
          </li>
          {items}
        </ul>
      );
    }

    return null;
  }

  render() {
    const {
      wrapperClassName,
      contentStyle,
      labelClassName,
      labelStyle,
      label,
    } = this.props;
    const finalStyle = {
      margin: 0,
      padding: 10,
      backgroundColor: '#fff',
      border: '1px solid #ccc',
      whiteSpace: 'nowrap',
      ...contentStyle,
    };
    const finalLabelStyle = {
      margin: 0,
      ...labelStyle,
    };
    const hasLabel = !_.isNil(label);
    const finalLabel = hasLabel ? moment(`${label}-01`).format('MMMM YYYY') : '';
    const wrapperCN = classNames('recharts-default-tooltip', wrapperClassName);
    const labelCN = classNames('recharts-tooltip-label', labelClassName);

    return (
      <div className={wrapperCN} style={finalStyle}>
        <p className={labelCN} style={finalLabelStyle}>
          {React.isValidElement(finalLabel) ? finalLabel : `${finalLabel}`}
        </p>
        {this.renderContent()}
      </div>
    );
  }
}

export default TooltipContent;
